import {Component, OnInit} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';
import {Matricola} from '../models/matricola';
import {UserService} from '../service/user.service';
@Component({
    selector: 'app-tws-matricole',
    templateUrl: './tws-matricole.component.html',
    styleUrls: ['./tws-matricole.component.css']
})
export class TwsMatricoleComponent implements OnInit {
    msg: string = "";
    ricerca: boolean = false;
    matricole: Array<Matricola> = new Array<Matricola>();//in teoria ho l'albero e posso metterlo in cache
    codice: string;
    descrizione: string;
    matricola: string;
   
    constructor(
    private ricambiService: RicambiService,
    private userService: UserService,
    ) {}

    ngOnInit() {
        this.ricerca=true;
        this.ricambiService.getMatricole().then(mac => this.risultatiRicerca(mac));
    }
    cercaMatricole(): void {
        this.ricerca = true;
        this.ricambiService.cercaMatricole(this.codice, this.descrizione, this.matricola).then(mac => this.risultatiRicerca(mac));
    }
    
    risultatiRicerca(mac: Matricola[]):void{
        this.ricerca=false;
        this.matricole=mac;
        this.toggle =false;
    }
    toggle: boolean = false;
    clickToggle(): void {
        this.toggle = !this.toggle;
    }
    
    get utente():any{
        return this.userService.getProfilo();
    }
}



// WEBPACK FOOTER //
// ./src/app/tws-matricole/tws-matricole.component.ts